import { render, staticRenderFns } from "./FullTextReviewActionControls.vue?vue&type=template&id=28213b70&scoped=true&"
import script from "./FullTextReviewActionControls.vue?vue&type=script&lang=js&"
export * from "./FullTextReviewActionControls.vue?vue&type=script&lang=js&"
import style0 from "./FullTextReviewActionControls.vue?vue&type=style&index=0&id=28213b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28213b70",
  null
  
)

export default component.exports